import { useQuery } from '@tanstack/react-query'
import { fetchSettings } from '@/lib/api/admin-settings'

export const settingsKeys = {
  all: ['admin-settings'] as const,
  list: () => [...settingsKeys.all, 'list'] as const,
}

export function useAdminSettings() {
  return useQuery({
    queryKey: settingsKeys.list(),
    queryFn: fetchSettings,
    staleTime: 30 * 1000,
  })
}
